import * as React from 'react'

import { CartSidebarSlotsProvider, VoucherCodesLayout } from '@grandvisionhq/carts-v2'
import { StoreWithPersistor } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/cart/overview'

import { withCms, withLayout } from '../../cms'
import { withCart } from '../../components/hocs/with-cart'
import { getDeliveryIndicatorConfig } from '../../configuration'

type Props = {
  store?: StoreWithPersistor
}

const CartOverview = (props: Props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <CartSidebarSlotsProvider
      slots={{
        SecondComponent: VoucherCodesLayout,
      }}
    >
      <Page store={props.store} delivery={{ indicatorConfig: deliveryIndicatorConfig }} />
    </CartSidebarSlotsProvider>
  )
}

export default compose<Props, Props>(
  withCms(),
  withLayout({ navigation: false }),
  withCart()
)(CartOverview)
